import { render, staticRenderFns } from "./add-point-cateogry-modal.vue?vue&type=template&id=0cb6030a&scoped=true&"
import script from "./add-point-cateogry-modal.vue?vue&type=script&lang=js&"
export * from "./add-point-cateogry-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-point-cateogry-modal.vue?vue&type=style&index=0&id=0cb6030a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6030a",
  null
  
)

export default component.exports